import * as Handlebars from 'handlebars/dist/handlebars.js';
import * as deloitteCookies from 'js-cookie/src/js.cookie.js';

/* eslint-disable */
// Closest - Polyfill for IE8+
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest =
    function (s) {
      var matches = (this.document || this.ownerDocument).querySelectorAll(s),
        i,
        el = this;
      do {
        i = matches.length;
        while (--i >= 0 && matches.item(i) !== el) { };
      } while ((i < 0) && (el = el.parentElement));
      return el;
    };
}

// includes - Polyfill for IE11+
if (!String.prototype.includes) {
  String.prototype.includes = function (search, start) {
    'use strict';
    if (typeof start !== 'number') {
      start = 0;
    }

    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// includes - Polyfill for IE11+
// From https://github.com/latusinski/polyfill-array-includes/blob/master/array-includes.js
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
/* eslint-enable */

export function createDynamicHTML(staticHTML, jsonData, otherOptions) {
  const templateScript = Handlebars.compile(staticHTML);
  const html = templateScript(jsonData);
  return html;
}

export async function doAjax(inputDataObj) {
  try {
    const result = await $.ajax(inputDataObj);
    return result;
  } catch (error) {
    return error;
  }
}

// export function showCustomLoader(elementID) {
//   const getDynamicID = `#${elementID}`;
//   $(getDynamicID).append('<div class="newCustomLoader"><img src="/_ui/responsive/ccl/assets/images/customLoader.gif" alt="custom loader image"/></div>');
// }

// export function removeCustomLoader(elementID) {
//   const getDynamicID = `#${elementID}`;
//   $(getDynamicID).find('.newCustomLoader').remove();
// }

export function showCustomLoader(elementID) {
  const getDynamicID = `#${elementID}`;
  $(getDynamicID).append('<div class="customLoader-Ajax"></div>');
}

export function removeCustomLoader(elementID) {
  const getDynamicID = `#${elementID}`;
  $(getDynamicID).find('.customLoader-Ajax').remove();
}

export function showLoader() {
  const getLoader = $('.loader');
  getLoader.empty().append('<div class="loading"><div><span role="alert" aria-live="polite">Loading...</span></div><img src="/_ui/responsive/ccl/assets/images/customLoader.gif" alt="custom loader image"/></div>');
  getLoader.show();
  $('#overlay').show();
}

export function showToast(element, time = 3000, errMsg = 'Something went wrong, Please try again.') {
  const x = $(element);
  x.html(errMsg);
  x.addClass('show');
  setTimeout(() => { x.className = x.removeClass('show'); }, time);
}

export function showGlobalToast(element, time = 4000, msg = 'Something went wrong, Please try again.') {
  const x = $(element);
  x.html(msg);
  x.addClass('show');
  setTimeout(() => { x.className = x.removeClass('show'); }, time);
}

export function hideLoader() {
  $('.loader').hide();
  $('#overlay').hide();
}

export function displayError(err) {
  const cartAPIError = { customError: err };
  hideLoader();
  console.log(cartAPIError);
}

export function showModal(modalID) {
  $(`#${modalID}`).modal();
}

export function hideModal(modalID) {
  $(`#${modalID}`).modal('hide');
}

export function detectmob() {
  if (window.innerWidth < 1024) {
    return true;
  }
  return false;
}

export function getSelectedGuests(selectedItems) {
  const tempArr = [];
  $.each(selectedItems, (index, value) => {
    value.split('-');
    if (!tempArr.includes(value.split('-')[0])) {
      tempArr.push(value.split('-')[0]);
    }
  });

  const productCard = [];
  $.each(tempArr, (index, value) => {
    const temp = selectedItems.filter((x) => x.split('-')[0] === value);
    const g = [];
    $.each(temp, (i, v) => {
      g.push({
        bookingId: v.split('-')[1],
        guestId: v.split('-')[2]
      });
    });
    productCard.push({
      variantId: value,
      guestList: g
    });
  });

  return productCard;
}

export function updateCartSummary(orderSummary) {
  if (orderSummary) {
    const currencySymbol = orderSummary.currency ? orderSummary.currency : '$';
    $('.cart-summary-subtotal')[0].innerHTML = `${currencySymbol}${orderSummary.subTotal}`;
    $('.cart-summary-gratuities')[0].innerHTML = `${currencySymbol}${orderSummary.gratuities}`;
    if ($('.cart-summary-surcharges').length) {
      $('.cart-summary-surcharges')[0].innerHTML = `${currencySymbol}${orderSummary.portSurcharges}`;
    }
    if (!orderSummary.checkoutDisabled) {
      $('.proceed-to-checkout-btn').removeAttr('disabled');
    }
    $('.cart-summary-totaltax')[0].innerHTML = orderSummary.hideTax ? 'TBD' : `${currencySymbol}${orderSummary.totalTax}`;
    $('.cart-summary-servicefee')[0].innerHTML = `${currencySymbol}${orderSummary.serviceFeesTotal}`;
    if ($('.placeOrderCartSummary').length) {
      $('.total-cost')[0].innerHTML = `${currencySymbol}${orderSummary.totalPriceWithTax}`;
      if ($('.sticky-total').length) {
        $('.sticky-total')[0].innerHTML = `Total: ${currencySymbol}${orderSummary.totalPriceWithTax}`;
      }
    } else {
      $('.total-cost')[0].innerHTML = `${currencySymbol}${orderSummary.totalPrice}`;
      if ($('.sticky-total').length) {
        $('.sticky-total')[0].innerHTML = `Total: ${currencySymbol}${orderSummary.totalPrice} <img src="/_ui/responsive/ccl/assets/icons/down_blue.svg" alt="arrow image" class="sticky-total-arrow">`;
      }
    }
  }
}

export function updateCouponSummary(response) {
  if (response.couponDetails) {
    let temp = '';
    $('.promo-added').empty();
    $.each(response.couponDetails, (i, v) => {
      if (v.couponAmount) {
        v.couponAmount = v.couponAmount.toFixed(2);
        temp += `<div class="promo-applied row-${v.couponCode}">
          <div class="inner-promo-applied">
            <div class="show-promo">PROMO:<span class="promo-code-text" aria-live="assertive" role="alert" aria-label="promo ${v.couponCode} applied">${v.couponCode}</span>
            <a href="#" class="remove-promo" aria-label="remove applied promo ${v.couponCode}" data-promocode="${v.couponCode}">Remove</a>
            </div>
            <div class="discount">-$${v.couponAmount}</div>
          </div>
          <div class="remove-error-div"></div>
        </div>`;
        // $(`.promo-applied.row-${v.couponCode} .discount`)[0].innerHTML = `-$${v.couponAmount.toFixed(2)}`;
      } else {
        $(`.promo-applied.row-${v.couponCode} .discount`).hide();
      }
    });
    $('.promo-added').append(temp);
    $('.promo-added').show();
  }
}

export function updateProductSummary(orderSummary) {
  if (orderSummary && orderSummary.allProductDetails) {
    const currencySymbol = orderSummary.currency ? orderSummary.currency : '$';
    $.each(orderSummary.allProductDetails, (i, v) => {
      let tempHtml = '';

      if ($(`.cart-summary-item-${v.productId} .cart-card-body .price`).length) {
        $(`.cart-summary-item-${v.productId} .cart-card-body .price`)[0].innerHTML = `${currencySymbol}${v.toPrice}`;
      }
      // Hide/Show wheelchair text on cart product
      if ($(`.card-${v.productId} .is-wheelchair`).length) {
        if (v.specialService) {
          $(`.card-${v.productId} .is-wheelchair`).show();
        } else {
          $(`.card-${v.productId} .is-wheelchair`).hide();
        }
      }
      if ($(`.card-${v.productId} .cart-card-body .price`).length) {
        $(`.card-${v.productId} .cart-card-body .price`)[0].innerHTML = `${currencySymbol}${v.toPrice}`;
        if (v.fromPrice && (v.toPrice !== v.fromPrice)) {
          $(`.card-${v.productId} .cart-card-body .price`).attr('role', 'textbox');
          $(`.card-${v.productId} .cart-card-body .price`).attr('aria-label', `is from ${currencySymbol}${v.toPrice} now`);
        }
      }
      if ($(`.card-${v.productId} .cart-card-body .from-price`).length) {
        if (v.showStrikeOutPrice && (v.toPrice !== v.fromPrice)) {
          $(`.card-${v.productId} .cart-card-body .from-price`)[0].innerHTML = `From <span role='textbox' aria-label='was from ${currencySymbol}${v.fromPrice} before'>${currencySymbol}${v.fromPrice}</span>`;
        } else if (!v.promotionsDetail.length) {
          $(`.card-${v.productId} .cart-card-body .from-price`)[0].innerHTML = '';
        }
      }

      if ($(`.card-${v.productId} .cart-card-body .cart-product-qty-${v.productId}`).length) {
        $(`.card-${v.productId} .cart-card-body .cart-product-qty-${v.productId}`)[0].innerHTML = v.quantityAdded;
      }

      $.each(v.promotionsDetail, (ind, val) => {
        tempHtml += `<div class="savings-wrap">
                      <img src="/_ui/responsive/ccl/assets/icons/tag.svg" alt="savings-tag">
                      <div class="list-item savings">${val.promoDescription}</div>
                    </div>`;
      });
      if ($(`.card-${v.productId} .cart-card-body .savings-wrap-container`).length) {
        $(`.card-${v.productId} .cart-card-body .savings-wrap-container`)[0].innerHTML = tempHtml;
      }
    });
  }
}

export function pdpGetSelectedData() {
  const bookingIds = [];
  const guestIds = [];
  const ageCodes = [];
  const qty = $('.pdpQty').data('pdpqty');
  const checkedLength = $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]:checked').length;
  $('.custom-control.custom-checkbox.stateroom-check > input[type="checkbox"]').each((index, element) => {
    if (!element.checked) {
      $('.common-pdp-error-message .error').hide();
      if (qty === checkedLength) {
        element.disabled = true;
        element.parentElement.classList.add('stateroom-disabled');
        $('.common-pdp-error-message .error').html("There are not enough spots to accommodate other stateroom's guest.").show();
      } else if (element.dataset.conflict === 'false') {
        element.disabled = false;
        element.parentElement.classList.remove('stateroom-disabled');
      }
    }
  });

  $('.custom-checkbox input[type="checkbox"]:checked').each((index, element) => {
    if (element.hasAttribute('data-bookingid') && !$(element).hasClass('dining-stateroom-disable')) {
      bookingIds.push(element.getAttribute('data-bookingid'));
    }
  });

  if ($('.custom-checkbox .guests-check input[type="checkbox"]').length) {
    $('.custom-checkbox .guests-check input[type="checkbox"]:checked').each((i, elem) => {
      if (elem.hasAttribute('data-guestid') && !$(elem).prop('disabled') && !$(elem).hasClass('dining-guest-disable')) {
        guestIds.push(elem.getAttribute('data-guestid'));
      }
      if (elem.hasAttribute('data-agecode') && elem.getAttribute('data-agecode') !== '' && !$(elem).prop('disabled')) {
        ageCodes.push(elem.getAttribute('data-agecode'));
      }
    });
    $('.pdp-add-to-cart-btn').attr('data-agecodes', ageCodes.toString());
    $('.pdp-add-to-cart-btn').attr('data-guestIds', guestIds.toString());
  }

  $('.pdp-add-to-cart-btn').attr('data-bookingIds', bookingIds.toString());
  if (bookingIds.length && !$('.pdp-add-to-cart-btn').hasClass('atc-xdining')) {
    $('.pdp-add-to-cart-btn').removeAttr('disabled');
  } else {
    $('.pdp-add-to-cart-btn').attr('disabled', 'disabled');
  }
}

export function checkboxCheck() {
  // Auto Select Single Stateroom
  if (!$('.c-cart').length && !$('.dining-atc-modal-dialog').length) {
    const stateroomLength = $('.stateroom-info .parent-check').length;
    if (stateroomLength === 1) {
      if (!$('.stateroom-info .parent-check').prop('disabled')) {
        setTimeout(() => {
          $('.stateroom-info input.parent-check').trigger('click');
        }, 800);
      }
    }
  }


  $(document.body).on('click', '.custom-control.custom-checkbox.stateroom-check > input', (event) => {
    $(event.currentTarget.offsetParent).find('.booking-dropdown .guests-check input').each((index, element) => {
      if (!element.closest('.stateroom-disabled')) {
        element.checked = event.currentTarget.checked;
      }
    });
    pdpGetSelectedData();
  });

  $(document.body).on('click', '.booking-dropdown .guests-check input', (event) => {
    const disableGuestsLength = $(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .stateroom-disabled').length;
    const notAllChildsChecked = ($(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .custom-control-input').not(':checked').length - disableGuestsLength) === ($(event.currentTarget.offsetParent.offsetParent).find('.booking-dropdown .custom-control-input').length - disableGuestsLength);
    $(event.currentTarget).closest('.stateroom-check')[0].firstElementChild.checked = !notAllChildsChecked;
    const stateRoom = $(event.target).closest('.stateroom-check');
    if (stateRoom.find('.booking-dropdown .guests-check input:checked').not(':disabled').length === 0) {
      stateRoom.find('.parent-check').prop('checked', false);
    } else {
      stateRoom.find('.parent-check').prop('checked', true);
    }
    pdpGetSelectedData();
  });
}

export function returnAjaxData(ajaxResponse) {
  return ajaxResponse;
}


export function getBookingBuddyModalUrl(statusCode) {
  if (statusCode) {
    return `/_ui/responsive/ccl/assets/templates/booking-buddy/bb-modal-status-${statusCode}.html`;
  }
  return '/_ui/responsive/ccl/assets/templates/booking-buddy/bb-modal-status-initial.html';
}

export function getBookingBuddyModalHtml(statusCode, returnData) {
  const ajaxUrl = getBookingBuddyModalUrl(statusCode);
  $.ajax({
    type: 'GET',
    url: ajaxUrl
  }).done((response) => {
    returnData(response);
  }).fail(() => {
    console.log('error while loading booking buddy html');
  });
}

export function setSailingContextCookie(sailingId) {
  deloitteCookies.remove('SailingContextCookie');
  deloitteCookies.set('SailingContextCookie', sailingId);
}

export function setCarnivalGiftingBookingCookie(userId, requestParams) {
  deloitteCookies.remove(`carnivalGiftingBookingCookie-${userId}`);
  deloitteCookies.set(`carnivalGiftingBookingCookie-${userId}`, requestParams);
}

export function validateEmail(email) {
  const re = /\S+@\S+\.\S+/;
  return re.test(String(email).toLowerCase());
}

export function validateDob(input) {
  const pattern = /^(0?[1-9]|1[012])[-](0?[1-9]|[12][0-9]|3[01])[-]\d{4}$/;
  return pattern.test(input);
}


export function updateHeaderCartWidget(response) {
  if (response.totalItemsCount && response.totalItemsCount > 0) {
    if ($('.c-cart').length) {
      $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/itemsincart.svg');
    } else {
      $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/cart.svg');
    }

    $('span.items-in-cart').html(response.totalItemsCount).show();
    $('span.items-in-cart').parents('.fav-wrap a').attr('aria-label', `items in cart are ${response.totalItemsCount}`);
    $('span.items-in-cart').parents('.cart-mob a').attr('aria-label', `items in cart are ${response.totalItemsCount}`);
  } else if (response.removeSuccess) {
    $('.items-in-icon').attr('src', '/_ui/responsive/ccl/assets/icons/cart.svg');
    $('span.items-in-cart').hide();
  }
}

export function updateHeaderFavoriteWidget(response) {
  // {"wishlistItemCount":3,"redirectionURL":null,"productAdded":true,"productRemoved":false}
  $('span.items-in-favorite').addClass('black-color').removeClass('d-none');
  $('span.items-in-favorite').html(response.wishlistItemCount).show();
}

function splitText(text, textLimit) {
  let first = text.substring(0, textLimit);
  let spaceStr = 0;
  let secondString = '';
  if (text.substr(textLimit, 1) === ' ') {
    spaceStr = 1;
  }
  let second = text.substring(textLimit);
  const aux = second.substring(0, second.indexOf(' '));
  first = first.substring(0, textLimit) + aux;
  const spaceIndex = second.indexOf(' ');
  second = ` ${second.substring(spaceIndex + 1)}`;
  secondString = spaceStr === 0 ? second.trim() : second;
  const bothTextes = [first, secondString];
  return bothTextes;
}

export function seeMoreLess(paraClassName, prodTitle) {
  /* eslint-disable */
  let textLimit = 300;
  if ($(paraClassName).parents('.expectation').length > 0) {
    textLimit = 150;
  }
  $(paraClassName).each((index, element) => {
    if (Object.prototype.toString.call(paraClassName) !== '[object String]') {
      paraClassName = `.${paraClassName[0].classList[0]}`;
    }
    const text = $(element).text();
    if (text.length > textLimit) {
      const textArray = splitText(text, textLimit);
      element.innerHTML = textArray[0];
      $(element).append(`<span class='show-more'>&nbsp;&nbsp;<a href='javascript:;' aria-live="assertive" class='morelink' aria-expanded='false' aria-label='Read more information about ${prodTitle}'>Read More <img src='/_ui/responsive/ccl/assets/icons/down_blue.svg' alt='down arrow'></a></span>`);
      $(element).append(`<span style="display: none" class='rest-of-description'>${textArray[1]}</span>`);
      $(element).append(`<span style="display: none" class='red show-less'>&nbsp;&nbsp;<a href='javascript:;' aria-expanded='true' aria-label='Read less information about ${prodTitle}' class='morelink'>Read Less <img src='/_ui/responsive/ccl/assets/icons/up_blue.svg' alt='down arrow'></a></span>`);
    } else {
      element.innerHTML = text;
    }
    /* eslint-enable */
    $($(element).children('.show-more')).click((e) => {
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').show();
      $(e.currentTarget).parents(paraClassName).children('.show-less').show();
      $(e.currentTarget).parents(paraClassName).children('.show-less').addClass('ccl-ada-focus');
      $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink')
        .hide();
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').focus();
      setTimeout(() => {
        $(e.currentTarget)
          .parents(paraClassName)
          .children('.show-less')
          .children('.morelink')
          .addClass('ada-element-focus');
        $(e.currentTarget)
          .parents(paraClassName)
          .children('.show-less')
          .children('.morelink')
          .focus();
      }, 500);

      $(e.currentTarget)
        .parents(paraClassName)
        .children('.show-more')
        .children('.morelink')
        .removeAttr('aria-label');
    });

    $($(element).children('.red.show-less')).click((e) => {
      $(e.currentTarget).parents(paraClassName).children('.rest-of-description').hide();
      $(e.currentTarget).parents(paraClassName).children('.show-more').children('.morelink')
        .show();
      $(e.currentTarget).parents(paraClassName).children('.show-more').addClass('ccl-ada-focus');
      $(e.currentTarget).parents(paraClassName).children('.show-less').hide();
      // $(e.currentTarget).parents(paraClassName).children('.show-more').focus();
      setTimeout(() => {
        $(e.currentTarget)
          .parents(paraClassName)
          .children('.show-more')
          .children('.morelink')
          .addClass('ada-element-focus');
        $(e.currentTarget)
          .parents(paraClassName)
          .children('.show-more')
          .children('.morelink')
          .focus();

        $(e.currentTarget)
          .parents(paraClassName)
          .children('.show-more')
          .children('.morelink')
          .attr('aria-label', `Clickable Read more information about ${prodTitle} collapsed link`);
      }, 500);
    });
  });
}
export function updateFacetData(excursionsCountForFacet) {
  for (let i = 0; i < excursionsCountForFacet.length; i++) {
    if (excursionsCountForFacet[i].excursionCartMessage && excursionsCountForFacet[i].excursionOrderMessage) {
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionCart').text(excursionsCountForFacet[i].excursionCartMessage);
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionOrder').text(excursionsCountForFacet[i].excursionOrderMessage);
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionCart').removeClass('show-excursion');
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionOrder').removeClass('show-excursion');
    } else if (excursionsCountForFacet[i].excursionCartMessage) {
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionCart').text(excursionsCountForFacet[i].excursionCartMessage);
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionCart').removeClass('show-excursion');
    } else if (excursionsCountForFacet[i].excursionOrderMessage) {
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionOrder').text(excursionsCountForFacet[i].excursionOrderMessage);
      $(`.${excursionsCountForFacet[i].code}`).find('.excursionOrder').removeClass('show-excursion');
    }
  }
}

export function getFocusableElements(modalEl, pos) {
  const tabbables = '[href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]):not([style*="display:none"]):not(.owl-next):not(.owl-prev):not(.owl-dot):not(.disabled):not([class*="d-none"])';
  const firstFocusable = modalEl.find(tabbables).first();
  const lastFocusable = modalEl.find(tabbables).last();
  return (pos === 'last') ? lastFocusable : firstFocusable;
}

export function sasEvents(eventName, data) {
  // SAS event
  const isSasEnabled = $('body').find('#isSasEnabled').val();
  if (isSasEnabled === 'true' || isSasEnabled === true) {
    setTimeout(() => {
      if (data && typeof window.ci360 !== 'undefined') {
        window.ci360(eventName, data);
      }
    }, 100);
  }
}

export function removeParam(key, sourceURL) {
  let rtn = sourceURL.split('?')[0];
  let param;
  let paramsArr = [];
  const queryString = (sourceURL.indexOf('?') !== -1) ? sourceURL.split('?')[1] : '';
  if (queryString !== '') {
    paramsArr = queryString.split('&');
    for (let i = paramsArr.length - 1; i >= 0; i -= 1) {
      /* eslint-disable */
      param = paramsArr[i].split('=')[0];
      /* eslint-enable */
      if (param === key) {
        paramsArr.splice(i, 1);
      }
    }
    rtn = `${rtn}?${paramsArr.join('&')}`;
  }
  return rtn;
}


export function isElementPartiallyInViewport(el) {
  const rect = el[0].getBoundingClientRect();
  // DOMRect { x: 8, y: 8, width: 100, height: 100, top: 8, right: 108, bottom: 108, left: 8 }
  const windowHeight = (window.innerHeight || document.documentElement.clientHeight);
  const windowWidth = (window.innerWidth || document.documentElement.clientWidth);

  // http://stackoverflow.com/questions/325933/determine-whether-two-date-ranges-overlap
  const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0);
  const horInView = (rect.left <= windowWidth) && ((rect.left + rect.width) >= 0);

  return (vertInView && horInView);
}

export function debounce(fn, delay) {
  let timeoutID;
  return (...args) => {
    if (timeoutID) clearTimeout(timeoutID);
    timeoutID = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}


export function ajaxForCruiseCashCartAmount() {
  return $.ajax({
    type: 'GET',
    url: '/shop/CruiseCashCartAmount'
  }).done((response) => {
    localStorage.setItem('cruisecashcartamount', response);
  }).fail(() => {
    console.log('Something went wrong on cruise ');
  });
}



// WEBPACK FOOTER //
// ./src/js/generalFunctions.js